if (document.readyState === "loading") {
	// DOM読み込み中なら読み込み後に共通のイベントを登録
	document.addEventListener("DOMContentLoaded", () => {
		commonFunction();
	});
} else {
	// DOM読み込み完了済みなら即登録（ブログサイト向け）
	commonFunction();
}

//--------------------------------------
// 共通のイベント処理
//--------------------------------------
var scrollpos;

function commonFunction() {
	// リンクのURLパラメータにサイト識別名を追加
	document.querySelectorAll("a").forEach((el) => {
		var href = el.getAttribute("href");
		const hrefArr = href.split("/");
		if (hrefArr[2] && hrefArr[2] == "unipos.me") {
			// aタグリンク先のドメインがunipos.meの場合、from=mediaのパラメータを追加
			if (href.includes("?")) {
				// すでにパラメータがある場合は追加
				href = href + "&from=media";
			} else {
				// 新規追加
				href = href + "?from=media";
			}

			el.setAttribute("href", href);
		}
	});

	// 目次の開閉
	if (document.getElementById("outline__btnToggle")) {
		document.getElementById("outline__btnToggle").addEventListener("click", function () {
			slideToggle(document.querySelector(".outline__content"), 500);
			this.classList.toggle("open");
			if (this.classList.contains("open")) {
				this.innerHTML = "非表示";
			} else {
				this.innerHTML = "表示する";
			}
		});
	}

	// SP menu
	var state = false;
	var scroll_open_flag = 0;

	window.addEventListener("pageshow", (e) => {
		if (e.persisted && state) {
			// SP向け ブラウザバック時にハンバーガーメニューが開いていた場合、閉じる
			scroll_open_flag = 0;
			document.querySelector("#js-hamberger_open").classList.remove("is-hidden");
			document.querySelector("#js-hamberger_scroll_open").classList.remove("is-hidden");
			document.querySelector("#js-header__logo").classList.remove("is-hidden");
			document.querySelector("#js-hamberger_close").classList.remove("is-active");
			document.querySelector("#js-header__nav").classList.remove("is-active");
			bodyFixedOff();
			if (document.querySelector("#intercom-container")) {
				document.querySelector("#intercom-container").style.display = "block";
			}
			state = false;
		}
	});

	// スクロール中にハンバーガーメニューを表示する
	window.addEventListener("scroll", (e) => {
		if (document.querySelector("#js-hamberger_scroll_open")) {
			if (document.documentElement.scrollTop > 500 || scroll_open_flag == 1) {
				document.querySelector("#js-hamberger_scroll_open").classList.add("is-active");
			} else {
				document.querySelector("#js-hamberger_scroll_open").classList.remove("is-active");
			}
		}
	});

	// ページ上部のハンバーガーメニュー押下時の開く処理
	if (document.querySelector("#js-hamberger_open")) {
		document.querySelector("#js-hamberger_open").addEventListener("click", () => {
			document.querySelector("#js-hamberger_open").classList.add("is-hidden");
			document.querySelector("#js-header__logo").classList.add("is-hidden");
			document.querySelector("#js-hamberger_close").classList.add("is-active");
			document.querySelector("#js-header__nav").classList.add("is-active");
			if (!state) {
				bodyFixedOn();
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "none";
				}
				state = true;
			} else {
				bodyFixedOff();
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "block";
				}
				state = false;
			}
		});
	}

	// スクロール途中のハンバーガーメニュー押下時の開く処理
	if (document.querySelector("#js-hamberger_scroll_open")) {
		document.querySelector("#js-hamberger_scroll_open").addEventListener("click", () => {
			scroll_open_flag = 1;
			document.querySelector("#js-hamberger_scroll_open").classList.add("is-hidden");
			document.querySelector("#js-header__logo").classList.add("is-hidden");
			document.querySelector("#js-hamberger_close").classList.add("is-active");
			document.querySelector("#js-header__nav").classList.add("is-active");
			if (!state) {
				bodyFixedOn();
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "none";
				}
				state = true;
			} else {
				bodyFixedOff();
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "block";
				}
				state = false;
			}
		});
	}

	// ハンバーガーメニューの閉じる処理
	if (document.querySelector("#js-hamberger_close")) {
		document.querySelector("#js-hamberger_close").addEventListener("click", () => {
			scroll_open_flag = 0;
			document.querySelector("#js-hamberger_open").classList.remove("is-hidden");
			document.querySelector("#js-hamberger_scroll_open").classList.remove("is-hidden");
			document.querySelector("#js-header__logo").classList.remove("is-hidden");
			document.querySelector("#js-hamberger_close").classList.remove("is-active");
			document.querySelector("#js-header__nav").classList.remove("is-active");
			if (!state) {
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "none";
				}
				state = true;
			} else {
				bodyFixedOff();
				if (document.querySelector("#intercom-container")) {
					document.querySelector("#intercom-container").style.display = "block";
				}
				state = false;
			}
		});
	}

	// headerハンバーガーメニュー内アコーディオンメニューのtoggle処理
	(function () {
		var toggleIcons = document.querySelectorAll(".js-header__toggleSp");
		toggleIcons.forEach(function (elm) {
			elm.addEventListener("click", function () {
				this.classList.toggle("is-active");
				this.nextElementSibling.classList.toggle("is-open");
			});
		});
	})();

	// （お役立ち資料・イベント情報）SP時のアコーディオンメニューの開閉処理
	if (document.querySelector("#js-category_toggle")) {
		document.querySelector("#js-category_toggle").addEventListener("click", () => {
			slideToggle(document.querySelector(".documentAnchor__listWrap"), 500);
			document.querySelector(".documentAnchor__toggleSp").classList.toggle("documentAnchor__toggleSp--active");
			document.querySelector("#js-category_toggle").classList.toggle("documentAnchor__titleWrap--active");
		});
	}

	// footerメニュー内アコーディオンメニューのtoggle処理
	(function () {
		var toggleIcons = document.querySelectorAll(".js-footer__toggleSp");
		toggleIcons.forEach(function (elm) {
			elm.addEventListener("click", function () {
				elm.classList.toggle("is-active");
				elm.nextElementSibling.classList.toggle("is-open");
			});
		});
	})();

	// ページ内リンクのスムーススクロール
	document.querySelectorAll('a[href^="#"]').forEach(function (e) {
		e.addEventListener("click", smoothScroll);
	});
}

// -----------------------------------
// モーダル表示時のbodyのスクロール制御
// -----------------------------------

// bodyのスクロールをロックする
function bodyFixedOn() {
	setPageScrollable(false);
}
// bodyのスクロールをロック解除
function bodyFixedOff() {
	setPageScrollable(true);
}

// bodyのスクロールロック制御
function setPageScrollable(scrollable) {
	if (!scrollable) {
		// スクロールロック
		scrollpos = document.documentElement.scrollTop;
		document.documentElement.style.overflow = "hidden";
		document.documentElement.style.position = "fixed";

		document.body.classList.add("is-fixed");
		document.body.style.top = -scrollpos + "px";
	} else {
		// スクロールロック解除
		document.documentElement.style.overflow = "auto";
		document.documentElement.style.position = "relative";

		document.body.classList.remove("is-fixed");
		document.body.style.top = 0;
		window.scrollTo(0, scrollpos);
	}
}

//--------------------------------------
// jQueryを再現した関数
//--------------------------------------

// アニメーション中かどうかを管理
var isAnimation = false;

// jQueryのslideToggleを再現
function slideToggle(el, duration = 300) {
	if (window.getComputedStyle(el).display === "none") {
		return slideDown(el, duration);
	} else {
		return slideUp(el, duration);
	}
}

// jQueryのslideUpを再現
function slideUp(el, duration = 300) {
	if (isAnimation) {
		// アニメーション中は何もしない
		return;
	}
	isAnimation = true;
	el.style.height = el.offsetHeight + "px";
	el.offsetHeight;
	el.style.transitionProperty = "height, margin, padding";
	el.style.transitionDuration = duration + "ms";
	el.style.transitionTimingFunction = "ease";
	el.style.overflow = "hidden";
	el.style.height = 0;
	el.style.paddingTop = 0;
	el.style.paddingBottom = 0;
	el.style.marginTop = 0;
	el.style.marginBottom = 0;
	setTimeout(() => {
		isAnimation = false;
		el.style.display = "none";
		el.style.removeProperty("height");
		el.style.removeProperty("padding-top");
		el.style.removeProperty("padding-bottom");
		el.style.removeProperty("margin-top");
		el.style.removeProperty("margin-bottom");
		el.style.removeProperty("overflow");
		el.style.removeProperty("transition-duration");
		el.style.removeProperty("transition-property");
		el.style.removeProperty("transition-timing-function");
	}, duration);
}

// jQueryのslideDownを再現
function slideDown(el, duration = 300) {
	if (isAnimation) {
		// アニメーション中は何もしない
		return;
	}
	isAnimation = true;
	el.style.removeProperty("display");
	let display = window.getComputedStyle(el).display;
	if (display === "none") {
		display = "block";
	}
	el.style.display = display;
	let height = el.offsetHeight;
	el.style.overflow = "hidden";
	el.style.height = 0;
	el.style.paddingTop = 0;
	el.style.paddingBottom = 0;
	el.style.marginTop = 0;
	el.style.marginBottom = 0;
	el.offsetHeight;
	el.style.transitionProperty = "height, margin, padding";
	el.style.transitionDuration = duration + "ms";
	el.style.transitionTimingFunction = "ease";
	el.style.height = height + "px";
	el.style.removeProperty("padding-top");
	el.style.removeProperty("padding-bottom");
	el.style.removeProperty("margin-top");
	el.style.removeProperty("margin-bottom");
	setTimeout(() => {
		isAnimation = false;
		el.style.removeProperty("height");
		el.style.removeProperty("overflow");
		el.style.removeProperty("transition-duration");
		el.style.removeProperty("transition-property");
		el.style.removeProperty("transition-timing-function");
	}, duration);
}

// jQueryのfadeInを再現
function fadeIn(ele, _duration = 300, noChangeDisplay = null) {
	const delay = 15;
	return new Promise(async (resolve, reject) => {
		const elem = ele;
		if (elem.style.display === "none" || elem.style.display === "") {
			const duration = _duration;
			let display = window.getComputedStyle(elem).display;
			if (display === "none") {
				display = "block";
			}
			if (!noChangeDisplay) {
				elem.style.display = display;
			}

			const coef = 1 / (duration / delay);
			if (!noChangeDisplay) {
				elem.style.opacity = 0;
			} else {
				elem.style.opacity = elem.style.opacity || 0;
			}
			var opacity = Number(elem.style.opacity);
			var animation = setInterval(() => {
				opacity += coef;
				elem.style.opacity = opacity;
				if (opacity >= 1) {
					clearInterval(animation);
					resolve(true);
				}
			}, delay);
		}
	});
}

// jQueryのfadeOutを再現
function fadeOut(ele, _duration = 300, noChangeDisplay = null) {
	const delay = 15;
	return new Promise(async (resolve, reject) => {
		const elem = ele;
		if (elem.style.display !== "none") {
			const duration = _duration;

			const coef = 1 / (duration / delay);
			if (!noChangeDisplay) {
				elem.style.opacity = 1.0;
			} else {
				elem.style.opacity = elem.style.opacity || 1.0;
			}
			var opacity = Number(elem.style.opacity);
			var animation = setInterval(() => {
				opacity -= coef;
				elem.style.opacity = opacity;
				if (opacity <= 0) {
					if (!noChangeDisplay) {
						elem.style.display = "none";
					}
					clearInterval(animation);
					resolve(true);
				}
			}, delay);
		}
	});
}

// スムーススクロール
const scroll_interval_ms = 10;
const scroll_move_division = 12;
const scroll_y_threhold = 1;
var scroll_y_shift = 0;
var scroll_y_diff;
var scroll_y;
var scroll_y_target;
var scroll_count;

function smoothScroll(event) {
	event.preventDefault();
	const targetId = (event?.target?.hash || event?.target?.parentNode?.hash).replace("#", "");
	scroll_start(targetId);
}
function scroll_start(p_target) {
	scroll_y = document.documentElement.scrollTop;
	scroll_y_diff = parseInt(document.getElementById(p_target).getBoundingClientRect().top);
	scroll_y_target = scroll_y_diff + scroll_y + scroll_y_shift;
	scroll(p_target);
}
function scroll(p_target, aTag) {
	scroll_count += 1;
	var y_move = scroll_y_diff / scroll_move_division;
	scroll_y += y_move;
	scrollTo(0, scroll_y);
	scroll_y_diff = scroll_y_target - scroll_y;

	if ((scroll_y_diff < 0 && scroll_y_target < scroll_y) || (0 < scroll_y_diff && scroll_y < scroll_y_target)) {
		if (Math.abs(scroll_y_diff) >= scroll_y_threhold) {
			setTimeout(function () {
				scroll(p_target);
			}, scroll_interval_ms);
		} else {
			scrollTo(0, scroll_y_target);
			document.querySelector("html").style.scrollBehavior = "auto";
		}
	} else {
		if (scroll_count == 1) {
			setTimeout(function () {
				scroll(p_target);
			}, scroll_interval_ms);
		} else {
			document.querySelector("html").style.scrollBehavior = "auto";
		}
	}
}
